import { IDataProviderFilter, IFilter } from 'core-components/types'
import { callSobTrendsPartnerSearch } from 'partner360/services/sobTrends/callSobTrendsPartnerSearch'

export const callSobTrendsPartnerSearchFromCrud = async (filter: IDataProviderFilter) => {
  const filters = filter.filters as IDataProviderFilter[]
  const orFilters = filters[0] ? (filters[0].filters as IFilter[]) : null
  if (!orFilters) {
    return { Data: [] }
  }
  const searchStr = orFilters.find((it) => it.field === 'SearchStr')?.value as string
  if (!searchStr || searchStr.length < 3) {
    return { Data: [] }
  }

  const data = await callSobTrendsPartnerSearch({ searchStr })

  return { Data: data }
}
